<template>
  <div>
    <aside :class="drawerClass">
      <div class="p-3 border-b">
        <router-link to="/">
          <Logo />
        </router-link>
      </div>

      <ul class="p-5">
        <li v-if="isAuthenticated" class="link mb-5">
          <router-link to="/events" class="font-semibold "
            >My Boxes</router-link
          >
        </li>
        <li v-if="isAuthenticated" class="link mb-5">
          <router-link to="/orders" class="font-semibold "
            >My Projects</router-link
          >
        </li>
        <li class="link mb-5" v-if="isAuthenticated && isCaterer">
          <router-link
            :to="{ name: 'caterer.dashboard' }"
            class="font-semibold "
            >My Catering Business</router-link
          >
        </li>
        <li class="link mb-5" v-if="isAuthenticated && isEventPlanner">
          <router-link
            :to="{ name: 'event-planner.dashboard' }"
            class="font-semibold "
            >My Event Business</router-link
          >
        </li>
        <li v-if="!isAuthenticated" class="link mb-5">
          <router-link to="/how-it-works" class="font-semibold "
            >How It Works</router-link
          >
        </li>
        <li v-if="!isAuthenticated" class="link mb-5">
          <router-link to="/pricing" class="font-semibold "
            >Pricing</router-link
          >
        </li>
        <li class="link mb-5">
          <a
            @click="$router.push(`/caterers/${caterer.uuid}/order`)"
            class="font-semibold mr-10"
          >Order from BuildaBox</a
          >
        </li>
        <li class="link mb-5">
          <router-link
            :to="{ name: 'segmentation-wizard' }"
            class="font-semibold "
            >Build Your Box</router-link
          >
        </li>
        <li v-if="!isAuthenticated" class="link mb-5">
          <router-link to="/auth/sign-in" class="font-semibold "
            >Sign In</router-link
          >
        </li>
        <li class="link mb-5" v-if="!isAuthenticated">
          <router-link to="/auth/sign-up" class="font-semibold">
            Sign Up
          </router-link>
        </li>
        <li v-if="isAuthenticated" class="link font-semibold" @click="_signOut">
          Sign out
        </li>
      </ul>
    </aside>
    <div
      v-if="drawerState"
      @click="toggleMenu(false)"
      class="overlay fixed top-0 left-0 w-full bg-gray-800 h-full z-40 opacity-50"
    ></div>
  </div>
</template>

<script>
import Logo from "./Logo";
import { mapActions, mapGetters } from "vuex";
import Api from "@/api/api_v1.0";

export default {
  name: "Drawer",
  components: {
    Logo
  },
  data() {
    return {
      caterer: {
        payments: []
      },
    };
  },
  async created() {
    await this.getCatererInfo('buildabox');
  },
  computed: {
    ...mapGetters(["isAuthenticated", "drawerState", "roles"]),

    isCaterer() {
      return this.roles?.includes("caterer");
    },

    isEventPlanner() {
      return this.roles?.includes("event_planner");
    },

    drawerClass() {
      let transitionType = this.drawerState
        ? " translate-x-0"
        : " -translate-x-full";

      let classes =
        "mobile-menu transform top-0 left-0 w-64 bg-white fixed h-full ease-in-out transition-all duration-300 z-50 shadow-md" +
        transitionType;

      return classes;
    }
  },

  watch: {
    $route(to, from) {
      if (this.$store.state.drawerState) {
        this.toggleMenu(false);
      }
    }
  },

  methods: {
    ...mapActions(["signOut"]),

    _signOut() {
      this.signOut();
      this.popupOpen = false;
      window.location.reload();
    },

    toggleMenu(state) {
      this.$store.commit("setDrawerState", state);
    },
    async getCatererInfo(slug) {
      const response = await Api.getCatererBySlug(slug);
      this.caterer = response.data;
    },
  }
};
</script>
